// IndexedDB setup
const DB_NAME = 'FABTournamentDB';
const DB_VERSION = 2; // Augmenté pour les nouvelles fonctionnalités
let db;

export const initDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    
    request.onerror = () => reject(request.error);
    request.onsuccess = () => {
      db = request.result;
      resolve(db);
    };
    
    request.onupgradeneeded = (e) => {
      const database = e.target.result;
      
      // Store pour les tournois
      if (!database.objectStoreNames.contains('tournaments')) {
        database.createObjectStore('tournaments', { keyPath: 'id' });
      }
      
      // Store pour les joueurs globaux
      if (!database.objectStoreNames.contains('players')) {
        database.createObjectStore('players', { keyPath: 'id' });
      }
    };
  });
};

// Fonctions pour les tournois
export const saveTournamentDB = async (tournament) => {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(['tournaments'], 'readwrite');
    const store = tx.objectStore('tournaments');
    const request = store.put(tournament);
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
};

export const loadTournamentDB = async (id) => {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(['tournaments'], 'readonly');
    const store = tx.objectStore('tournaments');
    const request = store.get(id);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
};

export const getAllTournamentsDB = async () => {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(['tournaments'], 'readonly');
    const store = tx.objectStore('tournaments');
    const request = store.getAll();
    request.onsuccess = () => resolve(request.result || []);
    request.onerror = () => reject(request.error);
  });
};

export const deleteTournamentDB = async (id) => {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(['tournaments'], 'readwrite');
    const store = tx.objectStore('tournaments');
    const request = store.delete(id);
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
};

// Fonctions pour les joueurs
export const savePlayerDB = async (player) => {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(['players'], 'readwrite');
    const store = tx.objectStore('players');
    const request = store.put(player);
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
};

export const getAllPlayersDB = async () => {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(['players'], 'readonly');
    const store = tx.objectStore('players');
    const request = store.getAll();
    request.onsuccess = () => resolve(request.result || []);
    request.onerror = () => reject(request.error);
  });
};

export const deletePlayerDB = async (id) => {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(['players'], 'readwrite');
    const store = tx.objectStore('players');
    const request = store.delete(id);
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
};